<template>


<section >
  <article class="message">
  <div class="message-header" @dblclick="onEdit(activity)">

    <div>
      <b-field grouped group-multiline>
            
        <!-- <b-field > -->

          <span class="" style="font-size: 1.0em; min-width: 3em;">
              <i v-if="activity.channel == 'phone'" class="fas fa-phone" style="color: darkgrey; " aria-hidden="true"></i>
              <i v-if="activity.channel == 'email'" class="fas fa-envelope" style="color: darkgrey; " aria-hidden="true"></i>
              <i v-if="activity.channel == 'facebook'" class="fab fa-facebook" style="color: darkgrey; " aria-hidden="true"></i>
              <i v-if="activity.channel == 'skype'" class="fab fa-skype" style="color: darkgrey; " aria-hidden="true"></i>            
              <i v-if="activity.channel == 'twitter'" class="fab fa-twitter" style="color: darkgrey; " aria-hidden="true"></i>            
              <i v-if="activity.channel == 'address'" class="fas fa-home" style="color: darkgrey; " aria-hidden="true"></i>            
              <i v-if="activity.channel == 'other'" class="fas fa-bookmark" style="color: darkgrey; " aria-hidden="true"></i>
              <i v-if="activity.channel == 'reminder'" class="fas fa-exclamation-circle" style="color: darkgrey; " aria-hidden="true"></i>            
            </span>
        <!-- </b-field> -->

        <b-field >
          <span style="padding-right: 1em; font-size: 0.8em;">
            {{ activity.due.date | moment("DD/MM/YYYY") }}
            </span>
            
            <span style="padding-right: 0em; font-size: 0.8em;">
            {{ activity.due.dateTime | moment("HH:mm") }}
            </span>

            <div style="min-width: 3em;">
              <div v-if="activity.done">  
                <i class="fas fa-circle" style="margin-left: 0em; color: green; font-size: 1em;" aria-hidden="true"></i>
              </div>
              <!-- <div v-if="activity.status == 'OPEN'">  
                <i class="fas fa-circle" style="margin-left: 0em; color: purple; font-size: 1em;" aria-hidden="true"></i>
              </div> -->
            </div>
        </b-field>

        

        <!-- <span expanded>
          {{channel.info}}
        </span> -->

      </b-field>
      <!-- </b-field> -->


      <b-field grouped group-multiline>
        <div style="min-width: 3em;">
          <div v-if="activity.done">  
            <i class="fas fa-circle" style="margin-left: 0em; color: green; font-size: 1em;" aria-hidden="true"></i>
          </div>
          <!-- <div v-if="activity.status == 'OPEN'">  
            <i class="fas fa-circle" style="margin-left: 0em; color: purple; font-size: 1em;" aria-hidden="true"></i>
          </div> -->
        </div>
       
        <div v-for="group in activity.groups" :key="group">
          <div class="tag" style=" background: green; color: white; margin-right: 0.3em;" >
           <!-- style="margin:0.2em; padding:0.2em; min-width: 3em; background: orange; color: white;" -->
            {{group}}
          </div>
        </div>

        <div v-for="contact in activity.contacts" :key="contact.id">
          <div  class="tag" style="background: orange; color: white; margin-right: 0.3em;" >
          <!-- style="margin:0.2em; padding:0.2em; min-width: 3em; background: green; color: white;" -->
            {{contact.displayName}}
          </div>
        </div>

      </b-field>

      <b-field grouped  group-multiline>
        <div style="min-width: 3em;"/>

        <b-field>
          <div style="margin-top: 5px; margin-bottom: 5px;">{{activity.header  | truncate(45) }}</div>
          <div v-if="activity.header.length == 0" style="margin-top: 5px; margin-bottom: 5px;">{{activity.message  | truncate(45) }}</div>
        </b-field>
      </b-field>

    </div>  

     
    <!-- <b-field grouped group-multiline style="" > -->
      <div aria-label="toggle" @click.prevent="onToggleOpen">
        <i class="fas fa-chevron-circle-down" style="font-size:1.8em;" v-if="!isOpen" ></i>
        <i class="fas fa-chevron-circle-up" style="font-size:1.8em;" v-if="isOpen" ></i>
      </div>
    <!-- </b-field>   -->

    
  </div>
  <div class="message-body"  v-if="isOpen">
    
    <b-field grouped group-multiline>
      

        <div v-for="group in activity.groups" :key="group">
          <div class="tag" style="margin:0.2em; padding:0.2em; min-width: 3em; background: green; color: white;">
            {{group}}
          </div>
        </div>

        <div v-for="user in activity.contacts" :key="user.id">
          <div class="tag" style="margin:0.2em; padding:0.2em; min-width: 3em; background: orange; color: white;">
            {{user.displayName}}
          </div>
        </div>

    </b-field>

    <b-field style="margin-top: 1em;" >

      <b-field label="Header" label-position="on-border">
        <b-input disabled  type="text" v-model="activity.header"></b-input>
      </b-field>
    </b-field>

    <b-field>

      <b-field label="Message" label-position="on-border">
        <!-- <div style="background: darkgrey; margin-top: 5px; margin-bottom: 5px;">
          {{activity.message }}
        </div> -->
        <b-input disabled type="text" v-model="activity.message"></b-input>
      </b-field>
    </b-field>


<!-- 
    <b-field label="Type" label-position="on-border">
              <b-select placeholder="Select Type" expanded v-model="activity.status" 
                    @keypress.prevent icon="arrow-circle-right" icon-pack="fas">
                <option value="" disabled>Select Status</option>    
                <option value="OPEN ">Open</option>
                <option value="DONE">Done</option>
                <option value="POSTPONED">Postponed</option>
                <option value="CANCELLED">Cancelled</option>
                
              </b-select>
            </b-field>
    <br>
      TODO
      <br>
      created: {{activity.createdate | moment("DD/MM/YYYY")}}
      <br>
      action: {{activity.actiondate | moment("DD/MM/YYYY")}}
      <br>
      channel: {{activity.channel}}
      <br>
      type: {{activity.type}}
      <br>
      status: {{activity.status}} 
-->

        <b-switch v-model="activity.done">Mark done</b-switch>

        <b-button class="button is-primary" @click="onSave">
          SAVE
        </b-button>
        
        <!-- <b-button @click="onEdit(activity)">
          EDIT
        </b-button> -->


        
  </div>

  </article>


</section>
</template>

<script>

import {mapActions} from 'vuex'
 
export default {

  name: 'ListPanelItem',
  components: {
    
  },
  data() {
    return  {
      isOpen: false,
      // localActivity: {},
    }
  },
  props: {
    activity: {},
  },
  created () {
    // this.localActivity = JSON.parse(JSON.stringify(this.activity))
  },
  filters: {
    /**
    * Filter to truncate string, accepts a length parameter
    */
    truncate(value, length) {
        return value.length > length
            ? value.substr(0, length) + '...'
            : value
    }
  },
  computed: {
    // isRead: this.contact.status==='read' ? true: false
  },
  methods: {
    ...mapActions(['putSelectedActivity', 'updateActivity']), 
    onToggleOpen () {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.putSelectedActivity(this.activity)
      } else {
        this.putSelectedActivity(null)
      }
    },
    onEdit(activity) {
      this.putSelectedActivity(activity)
    },
    onSave () {
      if (this.activity.id.length > 0) {
        this.updateActivity(this.activity)
      } 
      // if (this.localActivity.id.length > 0) {
      //   this.updateActivity(this.localActivity)
      // } 
      // else {
      //   this.addNewActivity(this.localActivity)
      // }
      
      this.putSelectedActivity(this.activity)
      // 
    },

    // isread (status) {
    //   if (status==='read') return true;
    //   return false;
    // }
    
  },
  watch: {
    // activity (newVal) {
    //   console.log('watch triggered> ListPanelItem @activity')
    //   this.localActivity = JSON.parse(JSON.stringify(newVal))
    // }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .read {
    background: green;
  }
</style>